import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm, ExpenseMixin],
  name: 'FormSearchComission',
  components: {
    AutocompleteZ
  },
  data () {
    return {
      consultacomissao: null,
      SearchItems: {
        empreendimentoId: '',
        DataInicio: '',
        DataFinal: '',
        statusSelecionado: '',
        clienteId: '',
        corretorId: '',
        cliente: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        corretor: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      comissaostatus: [
        {value: '', text: 'Todos os status'},
        {value: 0, text: 'Quitado'},
        {value: 1, text: 'Atrasado'},
        {value: 2, text: 'Em Andamento'}
      ]
    }
  },
  methods: {
    onLoad () {
      CommissionRepository.GetAllSearch()
        .then(Response => {
          this.consultacomissao = Response.data.data
        })
        .catch(() => {})
    },
    getCliente () {
      loading.push()
      usermanagement.GetAll()
        .then(Response => loading.pop())
        .catch(Error => loading.pop())
    },
    Clear () {
      localStoreHelper.imobiliaria.consultaComissoes(null)
      this.$refs.CommissionClientTypeahead.clear()
      this.$refs.CommissionTypeahead.clear()
      Object.keys(this.SearchItems).forEach(prop => {
        if (prop === 'cliente' || prop === 'corretor') {
          this.SearchItems[prop].value = ''
        } else {
          this.SearchItems[prop] = ''
        }
      })
      this.$emit('SearchItems', this.SearchItems, false)
    },
    Search () {
      this.SearchItems.clienteId = this.SearchItems.cliente.value
      var today = new Date()
      if (this.SearchItems.DataInicio !== '' && this.SearchItems.DataFinal === '') {
        this.SearchItems.DataFinal = today
      }
      this.SearchItems.corretorId = this.SearchItems.corretor.value
      this.$emit('SearchItems', this.SearchItems, true)
      localStoreHelper.imobiliaria.consultaComissoes(this.SearchItems)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/FormSearchComission/FormSearchComission.js